import React from 'react';
import { connect } from 'react-redux';

import './styles.scss';

const BestSellSection = ({ blocks }) => (
  // this class need to be add only packageListingMainWrap as parent class
  <div className="packageListingMainWrap">
    <div className="packageListingWrap">
      <div
        className="seo-blocks-section"
        dangerouslySetInnerHTML={{ __html: blocks }}
        suppressHydrationWarning
      />
    </div>
  </div>
);

const mapStateToProps = ({ seo }) => ({
  blocks: seo?.metaData?.blocks,
});

export default connect(mapStateToProps, null)(BestSellSection);
